import compose from 'recompose/compose';
import withState from 'recompose/withState';
import withHandlers from 'recompose/withHandlers';
import mapProps from 'recompose/mapProps';
import {embed} from '../../../../../../util/youtube';
import Video from './video';

const enhance = compose(
	withState('isLoading', 'setStatus', true),
	withHandlers({
		handleOnLoad: props => () => {
			props.setStatus(false);
		}
	}),
	mapProps(({file, isLoading, handleOnLoad}) => ({
		file,
		handleOnLoad,
		isLoading,
		youtube: embed(file.streaming)
	}))
);

export default enhance(Video);



// WEBPACK FOOTER //
// ./src/client/components/main/files/video/player/index.js